export default {"src":"/_next/static/image/public/images/ic_green_arrow_right.570d093374497cd4ec34eca6d4279e10.svg","height":24,"width":24};